import RpcService   from "@/core/services/Rpc/RpcService";
import type RpcResponse from "@/core/services/Rpc/RpcResponse";
import type Product     from '@/domains/Products/Product';

/**
 * DAO для работы с продуктами.
 * Тонкий pass-through к RPC — без бизнес-логики и гидрации.
 */
class ProductsDAO {

    /** Загружает продукт по ID */
    static async get(id: number): Promise<RpcResponse> {
        return await RpcService.makeRequest('products.get', { id });
    }

    /** Загружает список продуктов */
    static async getList(
        filters?: {
            pattern?: string;
            code?: string;
            codes?: string[];
            category?: { id: number };
            responsible?: { id: number };
            isAssigned?: boolean;
            seller?: { id: number };
            isCreatedImplicitly?: boolean;
            requireNestedObjects?: boolean;
            isService?: boolean;
        },
        pagination?: any,
        sort?: any,
    ): Promise<RpcResponse> {
        return await RpcService.makeRequest('products.getList', filters, pagination, sort,
          true,
          null,
          null,
          false,
          { abortPrevious: true }
        );
    }

    /** Создаёт продукт */
    static async add(product: Product): Promise<RpcResponse> {
        return await RpcService.makeRequest('products.add', { product });
    }

    /** Обновляет продукт */
    static async update(product: Product): Promise<RpcResponse> {
        return await RpcService.makeRequest('products.update', { product });
    }

    /** Удаляет продукт */
    static async delete(product: Product): Promise<RpcResponse> {
        return await RpcService.makeRequest('products.delete', { product });
    }
}

export default ProductsDAO;
